import { computed, type Ref } from 'vue';
import { useElementBounding } from '@vueuse/core';

function findScrollParent(el: HTMLElement): HTMLElement | null {
  let parent = el.parentElement;
  while (parent) {
    const { overflowY } = getComputedStyle(parent);
    if (overflowY === 'auto' || overflowY === 'scroll') return parent;
    parent = parent.parentElement;
  }
  return null;
}

export function useDropdownPosition(dropdownEl: Ref<HTMLElement | undefined>) {
  const trigger = computed(() => dropdownEl.value?.parentElement);
  const scrollParent = computed(() => {
    const t = trigger.value;
    return t ? findScrollParent(t) : undefined;
  });

  const { bottom: triggerBottom } = useElementBounding(trigger);
  const { height: dropdownHeight } = useElementBounding(dropdownEl);
  const { bottom: containerBottom } = useElementBounding(scrollParent);

  const flipAbove = computed(() => {
    if (!dropdownHeight.value) return false;
    const boundary = containerBottom.value || window.innerHeight;
    const spaceBelow = boundary - triggerBottom.value;
    return spaceBelow < dropdownHeight.value;
  });

  return { flipAbove };
}
